import axios from 'axios';

// Create a new instance of Axios
const api = axios.create({
    baseURL: process.env.REACT_APP_HOSST,
    // Add any other Axios configuration options you need
});

// Add a request interceptor to automatically add auth headers
api.interceptors.request.use(
    config => {
        // Get user data from localStorage
        const userFromLocalStorage = localStorage.getItem("user");
        if (userFromLocalStorage) {
            try {
                const user = JSON.parse(userFromLocalStorage);
                if (user?.token) {
                    config.headers.Authorization = `Bearer ${user.token}`;
                }
            } catch (error) {
                console.error("Error parsing user data for auth header:", error);
            }
        }
        return config;
    },
    error => Promise.reject(error)
);

// Add an interceptor for response errors
api.interceptors.response.use(
    response => response,
    error => {
        const {response} = error;
        // Check if the error response status is 401 (Unauthorized) and handle the error accordingly
        if (response && response.data.message === 'Expired JWT Token') {
            // Redirect to logout URL or perform any other action you desire
            localStorage.clear();
            window.location.href = '/logout';
        }
        return Promise.reject(error);
    }
);

export default api;
